<script setup lang="ts">
defineProps<{
    selected: boolean;
}>();
</script>

<template>
    <div
        class="flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-[#AFB8B8] bg-white transition-colors xl:mt-0.5"
    >
        <div v-if="selected" class="h-3 w-3 rounded-full bg-[#393734]"></div>
    </div>
</template>
